import React from 'react';
import cd from 'debug';
import core, { App } from '@gin-betting/core';

import { ParentPath } from 'types';
import SmartLink from '../SmartLink';
import GameLogo from '../GameLogo';
import './tournamentName.scss';

const debug = cd('components:TournamentName');

const {
    utils: { checkOnRoute },
} = core;

interface Props {
    tournamentName: string;
    masterId: string;
    sportId: string;
    slug: string;
    isDisabled?: boolean;
    route: ParentPath;
}

const TournamentName: React.FC<Props> = props => {
    debug('render', props);
    const { tournamentName, sportId, slug, isDisabled, route } = props;
    const isLinkDisabled =
        checkOnRoute(App.Routes.TOURNAMENT) ||
        checkOnRoute(App.Routes.RESULTS_LIST) ||
        isDisabled;

    const linkToTournament = `${route}${App.Routes.TOURNAMENT}${slug}`;

    return (
        <div styleName="container" className="__app-TournamentName-container">
            <GameLogo gameId={sportId} />
            {isLinkDisabled ? (
                <div styleName="tournamentName">
                    <span title={tournamentName}>{tournamentName}</span>
                </div>
            ) : (
                <SmartLink to={linkToTournament} styleName="tournamentName">
                    <span title={tournamentName}>{tournamentName}</span>
                </SmartLink>
            )}
        </div>
    );
};

export default TournamentName;
